import { Link } from "react-router-dom";
import { format } from "date-fns";
import { id as idLocale } from "date-fns/locale";
import { Button } from "@shared/components/Button";
import { useAsync } from "@shared/hooks/useAsync";
import { listIntros } from "./intros.api";

export function IntroListPage() {
  const { data, error, loading, reload } = useAsync(listIntros, []);

  return (
    <section>
      <header className="page-head">
        <h2>Pengantar Tes</h2>
      </header>

      {error && (
        <div role="alert" className="form-error">
          <p>{error}</p>
          <Button variant="secondary" onClick={reload}>
            Coba lagi
          </Button>
        </div>
      )}
      {loading && !data && !error && <p role="status">Memuat…</p>}

      {data && !error && (
        <table className="table">
          <thead>
            <tr>
              <th>Tes</th>
              <th>Pengantar</th>
              <th>Status isi</th>
              <th>Diperbarui</th>
              <th>Oleh</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.code}>
                <td>
                  <Link to={`/intros/${encodeURIComponent(row.code)}`}>{row.name}</Link>
                </td>
                <td>
                  <span className={`badge badge-status ${row.hasIntro ? "badge-published" : "badge-draft"}`}>
                    {row.hasIntro ? "Ada" : "Belum ada"}
                  </span>
                </td>
                <td>{row.hasIntro && row.isPlaceholder ? <span className="badge badge-placeholder">Placeholder</span> : "-"}</td>
                <td>{row.updatedAt ? format(new Date(row.updatedAt), "d MMM yyyy HH:mm", { locale: idLocale }) : "-"}</td>
                <td>{row.updatedByUsername ?? "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
